/* eslint-disable @typescript-eslint/no-explicit-any */

// Object comparison
export interface ObjectComparison {
  added: any;
  updated: {
    [propName: string]: any;
  };
  removed: any;
  unchanged: any;
}

/**
 * @return if obj is an Object, including an Array.
 */
export const isObject = (obj: any) => {
  return obj !== null && typeof obj === 'object';
};

// fix for deep object comparison: arrays and objects populate updated despite no changes
export const diffObject = (o1: any, o2: any, deep = false): ObjectComparison => {
  const added: any = {};
  const updated: any = {};
  const removed: any = {};
  const unchanged: any = {};
  for (const prop in o1) {
    if (o1.hasOwnProperty(prop)) {
      const o2PropValue = o2[prop];
      const o1PropValue = o1[prop];
      if (o2.hasOwnProperty(prop)) {
        if (o2PropValue === o1PropValue) {
          unchanged[prop] = o1PropValue;
        } else {
          updated[prop] =
            deep && isObject(o1PropValue) && isObject(o2PropValue)
              ? diffObject(o1PropValue, o2PropValue, deep)
              : { newValue: o2PropValue };
        }
      } else {
        removed[prop] = o1PropValue;
      }
    }
  }
  for (const prop in o2) {
    if (o2.hasOwnProperty(prop)) {
      const o1PropValue = o1[prop];
      const o2PropValue = o2[prop];
      if (o1.hasOwnProperty(prop)) {
        if (o1PropValue !== o2PropValue) {
          if (!deep || !isObject(o1PropValue)) {
            updated[prop].oldValue = o1PropValue;
          }
        }
      } else {
        added[prop] = o2PropValue;
      }
    }
  }
  return { added, updated, removed, unchanged };
};
